import { AnimationAction, BufferGeometry, Euler, Mesh, MeshStandardMaterial, Quaternion, Vector3 } from 'three';

export enum Language {
    DE = 'de',
    EN = 'en'
}

export enum Caption {
    Wirtschaft = 'Wirtschaft',
    Coronavirus = 'Coronavirus',
    Bayern = 'Bayern',
    Sport = 'Sport',
    Newsletter = 'Newsletter',
    Kultur = 'Kultur',
    Wissen = 'Wissen',
    Netzwelt = 'Netzwelt',
    Nachrichten = 'Nachrichten'
}

export enum SocialMedia {
    Facebook = 'Facebook',
    Twitter = 'Twitter',
    Mail = 'Mail',
    Whatsapp = 'Whatsapp'
}

export enum Author {
    MaximilianZierer = 'Maximilian Zierer',
    RobertSchoeffel = 'Robert Schöffel',
    SteffenKuehne = 'Steffen Kühne',
    HakanTanriverdi = 'Hakan Tanriverdi',
    NielsRingler = 'Niels Ringler',
    UliKoeppen = 'Uli Köppen',
    MichaelKreil = 'Michael Kreil',
    AnnKathrinWetter = 'Ann-Kathrin Wetter',
    VerenaNierle = 'Verena Nierle',
    LisaWreschniok = 'Lisa Wreschniok',
    SebastianBayerl = 'Sebastian Bayerl',
    ChristianSonnberger = 'Christian Sonnberger',
    ElisaHarlan = 'Elisa Harlan',
    OliverSchnuck = 'Oliver Schnuck',
    RebeccaCiesielski = 'Rebecca Ciesielski',
    SammyKhamis = 'Sammy Khamis'
}

export interface TextConfig {
    title: string;
    headline: string;
    headerInfo?: string;
    headerCredits?: string;
    description: string;
    interactiveNote?: string;
    keywords: string[];
    mobileShareText?: string;
    twitterShareText?: string;
    mailShareText?: string;
    whatsappShareText?: string;
    previewImage?: string;
}

export interface PageConfig {
    caption?: Caption;
    authors: Author[];
    url: string;
    provideEn?: boolean;
    ATId: string;
    headerImage: string;
    previewImage?: string;
}

export interface LayoutConfig {
    headerOverlay?: boolean;
    showAside?: boolean;
    showProgress?: boolean;
    titleInHeader?: boolean;
}

export interface NavbarSize {
    breakpoint: string;
    size: string;
}

export enum Navbar {
    SMALL,
    MEDIUM,
    LARGE
}

export enum Position {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT'
}

export enum Layout {
    COLUMN = 'column',
    ROW = 'row'
}

export type UserConfig = Omit<PageConfig, 'url'> & { de: TextConfig; en: TextConfig } & LayoutConfig;

export type MainConfig = PageConfig & TextConfig & LayoutConfig;

export interface AssetConfig {
    id: string;
    position: Vector3;
    title?: string;
    subTitle?: string;
    Component?: any;
    fading?: 'in' | 'out';
    ref?: Mesh<BufferGeometry, MeshStandardMaterial>;
}

export interface Animation {
    name: string;
    position?: Vector3;
    quaternion?: Quaternion;
    mode?: 'LoopOnce' | 'Loop' | 'LoopPingPong';
    repetitions?: number;
    action?: 'start' | 'stop' | 'reverse';
}

export interface CameraConfig {
    position: Vector3;
    quaternion: Quaternion;
    rotation?: Euler;
    name?: string;
    zoom?: number;
    far?: number;
    filmGauge?: number;
    filmOffset?: number;
    focus?: number;
    fov?: number;
    aspect?: number;
    target?: Vector3;
}

export interface Animations {
    [key: string]: AnimationAction & { name: string };
}

type Dict<T = any> = {
    [key: string]: T;
};

export interface BoardConfig {
    listensOnScroll?: boolean;
    frames: number;
    debug?: boolean;
    maxOpacity: number;
    assets: AssetConfig[];
    animations: Animations;
    assetTransformations: Dict<Dict<CameraConfig>>;
    depthAdjustmentList: string[];
    opacityAdjustmentList: string[];
    linesToDraw: any[];
    cameraConfigs: Dict<CameraConfig>;
    cameraSpeed: number;
}
